<template>
  <div class="cell-renderer-offline-online-new rater-buttons-wrapper">
    <div class="rater-buttons d-flex">
      <vs-button
          class="mr-2"
          size="small"
          :class="{'disabled': !offlineRateGuid}"
          :disabled="!offlineRateGuid"
          @click="offlineClicked"
          :style="offlineRaterButtonStyle"
      >
      <font-awesome-icon class="download-icon" :icon="['fal', offlineRaterIcon]" />
        {{ offlineButtonLabel }}
      </vs-button>
      <a
        :href="onlineRaterGuid || '#'"
        :target="onlineRaterGuid ? '_blank' : ''"
        class="onlinerater-button"
        :class="{'disabled': !onlineRaterGuid}"
      >
        <vs-button
            size="small"
            type="border"
            :class="{'disabled': !onlineRaterGuid}"
            :disabled="!onlineRaterGuid"
            :style="onlineRaterButtonStyle"
        >
          <font-awesome-icon class="download-icon" :icon="['fal', onlineRaterIcon]" />
          {{ onlineButtonLabel }}
        </vs-button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
name: 'CellRendererOfflineOnline',
computed: {
  offlineRaterButtonStyle() {
    let style = '';
    style += `background-color: ${this.params.offlineRaterCol.IconBackground} !important;`;
    style += `border-color: ${this.params.offlineRaterCol.IconBorder} !important;`;
    style += `color: ${this.params.offlineRaterCol.IconColour} !important;`;
    style += `font-size: ${this.offlineFontSize} !important;`;

    return style;
  },
  offlineRaterTypeId() {
    return this.params.offlineRaterCol.ID;
  },
  offlineRaterType() {
    return this.params.offlineRaterCol.Document_Type;
  },
  offlineRateGuid() {
    if (!this.params || !this.params.data) {
      return '';
    }

    return this.params.data[`DocumentType_${this.offlineRaterTypeId}`];
  },
  offlineRaterBackgroundColour () {
    return this.params.offlineRaterCol.IconColour;
  },
  offlineRaterIcon () {
    return this.params.offlineRaterCol.Icon || 'globe';
  },
  offlineFontSize() {
    return this.params.offlineRaterCol.IconSize || '14px';
  },
  offlineButtonLabel() {
    return this.params.offlineRaterCol.DisplayName || 'Offline';
  },
  onlineRaterButtonStyle() {
    let style = '';
    style += `background-color: ${this.params.onlineRaterCol.IconBackground} !important;`;
    style += `border-color: ${this.params.onlineRaterCol.IconBorder} !important;`;
    style += `color: ${this.params.onlineRaterCol.IconColour} !important;`;
    style += `font-size: ${this.onlineFontSize} !important;`;

    return style;
  },
  onlineRaterTypeId() {
    return this.params.onlineRaterCol.ID;
  },
  onlineRaterTypeId() {
    return this.params.onlineRaterCol.ID;
  },
  onlineRaterGuid() {
    if (!this.params || !this.params.data) {
      return null;
    }

    return this.params.data[`DocumentType_${this.onlineRaterTypeId}`];
  },
  onlineRaterBackgroundColour () {
    return this.params.onlineRaterCol.IconColour;
  },
  onlineRaterIcon () {
    return this.params.onlineRaterCol.Icon || 'file';
  },
  onlineFontSize() {
    return this.params.onlineRaterCol.IconSize || '14px';
  },
  onlineButtonLabel() {
    return this.params.onlineRaterCol.DisplayName || 'Online';
  },
},
methods: {
  offlineClicked() {
    this.download(
        this.offlineRateGuid,
        this.offlineRaterType,
        this.offlineRaterTypeId
    )
  },
  download(documentGuid, documentType, documentTypeId) {
    const params = {
      documentGuid: [documentGuid],
      documentType: 'salesDocument',
      documentTypeId
    };

    this.$parent.$emit('download', params);
  }
}
}
</script>

<style lang="scss">
@import '@/assets/scss/custom/components/variables';
.cell-renderer-offline-online-new {
  &.rater-buttons-wrapper {
    width: 100%;

    .rater-buttons {
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;

      .onlinerater-button {    
        width: 100%;
    
        &.disabled {
          cursor: initial;
        }

        > button {
          border-radius: 15px;
          padding: 6px !important;

          &:hover {
            background-color: #fff !important;
          }  
        }
      }

      button {
        border: none;
        border-radius: 15px;
        padding: 10.5px 8px !important;
        width: 100%;
        
        &.vs-button-border {
          padding: 10.5px 8px !important;
          border-width: 2px !important;
        }
      }

      .vs-button-primary.vs-button-filled:hover {
        box-shadow: none !important;
      }
    }
  }
}
</style>
